export interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  is_premium?: boolean;
}

/** 从 initData 字符串解析 Telegram 用户（initDataUnsafe.user 缺失时的兜底） */
export function parseTelegramUserFromInitData(initData: string): TelegramUser | null {
  if (!initData) return null;

  try {
    const params = new URLSearchParams(initData);
    const userRaw = params.get('user');
    if (!userRaw) return null;
    return JSON.parse(userRaw) as TelegramUser;
  } catch {
    return null;
  }
}

/** 从 v2board 登录响应中提取 token */
export function extractAuthToken(data: { auth_data?: string; token?: string } | undefined): string {
  const token = data?.auth_data || data?.token;
  if (!token) {
    throw new Error('登录响应缺少 token');
  }
  return token;
}
